import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
import "../../components/new.css";
import "../../components/new1.css";

 
 
let duration = 400;

 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
    
    
     
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="Recruiter Insights"
          image={"https://winpeforum.com/assets/ignite/cover.png"}
          description="CV In, Stress Out: Let's Ignite Up Your PEVC Future. Maximize Impact, Harness The Power of PEVC Insights and Accelerate Your Job Search with Our Panel of Experts."
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          
            <div className="container " style={{paddingTop:'20px'}}>
            
             <br/><br/><br/><br/><br/> <br/>
            <h1 className=" title" style={{color:'#bf2026', fontWeight:'700', textAlign:'left'}}>
                
           RECRUITER INSIGHTS</h1><br/> <br/>
          
             
           <div className="row">
        
               
            <div className="col-lg-4 col-md-4 col-sm-12">

               
            <iframe width="100%" height="195" src="https://www.youtube.com/embed/jmwx9WmKJB8?si=uSPpQvumPh0HhhE4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

              </div>
              
              <div className="col-lg-4 col-md-4 col-sm-12">

               
<iframe width="100%" height="195" src="https://www.youtube.com/embed/9v-u8bhSjnY?si=nW1-JaiwdsCDbkZY" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

  </div>

  <div className="col-lg-4 col-md-4 col-sm-12">

               
<iframe width="100%" height="195" src="https://www.youtube.com/embed/f4lOw-Z-WpI?si=0nYw-O6V40rcpme6" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

  </div>
  </div><br/> 
     
              </div>
 
              <br/><br/><br/><br/><br/><br/><br/><br/>
        

            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
           
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/RecruiterInsights/index.js